module.exports = __webpack_public_path__ + "static/media/Complexo de Golgi v3.09b1c8b9.glb";